import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const tienMatMenu: NavMenu = {
  title: 'Tiền mặt',
  items: [
    {
      title: 'Hạch toán',
      items: [
        {
          title: 'Phiếu thu',
          href: '/tien-mat/hach-toan/phieu-thu',
          group: 0
        },
        {
          title: 'Phiếu chi',
          href: '/tien-mat/hach-toan/phieu-chi',
          group: 0
        }
      ],
      group: 0
    },
    {
      title: 'Đề nghị thanh toán',
      items: [
        {
          title: 'Cập nhật đề nghị thanh toán',
          href: '/de-nghi-thanh-toan/cap-nhat',
          group: 1
        },
        {
          title: 'Duyệt đề nghị thanh toán',
          href: '/de-nghi-thanh-toan/duyet',
          group: 1
        }
      ],
      group: 0
    },
    {
      title: 'Tỷ giá ghi sổ',
      items: [
        {
          title: 'Tính tỷ giá ghi sổ',
          href: '/ty-gia-ghi-so/tinh',
          group: 2
        }
      ],
      group: 0
    },
    {
      title: 'Tạo phiếu thu từ hóa đơn',
      href: '/tao-phieu-thu-tu-hoa-don',
      group: 1
    },
    {
      title: 'Tạo phiếu chi từ hóa đơn',
      href: '/tao-phieu-chi-tu-hoa-don',
      group: 1
    },
    {
      title: 'Khai báo tài khoản kiểm tra chi âm',
      href: '/khai-bao-tai-khoan-kiem-tra-chi-am',
      group: 1
    },
    {
      title: 'Sổ quỹ',
      icon: <AritoIcon icon={542} />,
      items: [
        {
          title: 'Sổ quỹ tiền mặt',
          icon: <AritoIcon icon={542} />,
          href: '/tien-mat/so-quy/so-quy-tien-mat'
        },
        {
          title: 'Sổ nhật ký thu tiền',
          href: '/tien-mat/so-quy/so-nhat-ky-thu-tien'
        },
        {
          title: 'Sổ nhật ký chi tiền',
          href: '/tien-mat/so-quy/so-nhat-ky-chi-tien'
        },
        {
          title: 'Báo cáo số dư tại quỹ và ngân hàng',
          icon: <AritoIcon icon={566} />,
          href: '/tien-mat/so-quy/bao-cao-so-du-tai-quy-va-ngan-hang'
        },
        {
          title: 'Sổ kế toán chi tiết quỹ tiền mặt',
          href: '/tien-mat/so-quy/so-ke-toan-chi-tiet',
          group: 4
        }
      ],
      group: 2
    },
    {
      title: 'Tỷ giá ghi sổ',
      items: [
        {
          title: 'Bảng tỉ giá ghi sổ trung bình tháng',
          href: '/ty-gia-ghi-so/bang-trung-binh-thang'
        },
        {
          title: 'Bảng tỉ giá ghi sổ trung bình di động',
          href: '/ty-gia-ghi-so/bang-di-dong'
        }
      ],
      group: 2
    },
    {
      title: 'Đề nghị thanh toán',
      icon: <AritoIcon icon={572} />,
      items: [
        {
          title: 'Báo cáo tình trạng đề nghị thanh toán',
          icon: <AritoIcon icon={634} />,
          href: '/tien-mat/de-nghi-thanh-toan/bao-cao-tinh-trang-de-nghi-thanh-toan'
        }
      ],
      group: 2
    }
  ]
};
